function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormAccessRequestTableComponent from '@/apps/data-platform/components/FormAccessRequestTableComponent.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import PaginationSearching from '@/components/refactoring/PaginationSearching.vue';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import search_engine_service from '@/apps/data-platform/services/search_engine_service';
import ItemTableViewComponent from '@/apps/data-platform/modules/principal_search/components/ItemTableViewComponent.vue';
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, DEFAULT_TPL_FIELDS, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  components: {
    DialogsComponent: DialogsComponent,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent,
    PaginationSearching: PaginationSearching,
    ItemTableViewComponent: ItemTableViewComponent
  },
  props: {
    isAudience: {
      type: Boolean,
      default: false
    },
    isAttributes: {
      type: Boolean,
      default: false
    },
    isProductivize: {
      type: Boolean,
      default: false
    },
    productivizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      objToRequest: {},
      isRequest: false,
      queryResponse: {},
      messageEmptyList: textsDefaul.NOT_FOUND,
      textSearch: '',
      PAGE_SIZE: 10,
      pick_domain: window.userInfo.domain,
      existeBusqueda: false,
      isNewQuery: true,
      envConfig: envConfig,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      TAG_QUERIES: TAG_QUERIES,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      ALL_TABLES_OPTION: ALL_TABLES_OPTION,
      key_search_table: 1,
      external_row: null,
      page: 1,
      encontrado: {
        busqueda: [],
        found: 0,
        page: 1,
        per_page: 10,
        q: null,
        search_time_ms: 0
      },
      TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    // processd_list_domains: function() {
    //   let list_domains = []
    //   list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : []
    //   list_domains.unshift(window.userInfo.domain)
    //   return list_domains
    // },
    processd_list_domains: function processd_list_domains() {
      var list_domains = [];
      list_domains = window.userInfo ? Object.values(window.userInfo.listOrgs) : [];
      list_domains.unshift(window.userInfo.domain);
      // list_domains.push(ALL_TABLES_OPTION)
      return list_domains;
    },
    disabledDomain: function disabledDomain() {
      if (this.isAudience) {
        return false;
      }
      if (this.isProductivize) {
        return false;
      }
      return true;
    }
  }),
  unmounted: function unmounted() {
    this.isRequest = false;
    this.objToRequest = {};
  },
  watch: {
    queryResponse: function queryResponse(val) {
      tasks.combineTagsInRows(val);
      this.findQinData(val);
      return true;
    }
  },
  methods: {
    findQinData: function findQinData(queryResponse) {
      var qRegExPartial = new RegExp("".concat(this.$route.params.q), 'i');
      var tables = queryResponse.tables;

      // validate if has info
      if (!tables) return false;
      for (var i = 0; i < tables.length; i++) {
        var table = tables[i];
        var tableName = table.tableReference.tableId;
        var datasetName = table.tableReference.datasetId;
        var projectName = table.tableReference.projectId;
        var tags = table.tags;
        table.qFound = {
          element: '',
          name: ''
        };
        if (tableName.match(qRegExPartial)) {
          // validate q in table name
          table.qFound.element = 'Table name';
          table.qFound.value = tableName;
          // found in table name
          continue;
        } else if (datasetName.match(qRegExPartial)) {
          // validate in dataset name
          table.qFound.element = 'Dataset name';
          table.qFound.value = datasetName;
          // found in table name
          continue;
        } else if (projectName.match(qRegExPartial)) {
          // validate in dataset name
          table.qFound.element = 'Project id';
          table.qFound.value = projectName;
          // found in table name
          continue;
        } else {
          // search in columns values
          for (var j = 0; j < tags.length; j++) {
            var tag = tags[j];
            var columnName = tag.column; // if is column
            // let displayName = fields.displayName
            var fields = tag.fields; // if is table
            var keys = Object.keys(fields);
            for (var k = 0; k < keys.length; k++) {
              var tagName = keys[k];
              var field = fields[tagName];
              var stringValue = field.stringValue;
              // let boolValue = field.boolValue
              var enumValue = field.enumValue;
              // find
              var foundInstringValue = stringValue && stringValue.match(qRegExPartial);
              var foundInenumValue = enumValue && enumValue.displayName && enumValue.displayName.match(qRegExPartial);
              if (foundInstringValue || foundInenumValue) {
                // find in column value
                table.qFound.element = "Column value \"".concat(columnName || tagName, "\"");
                // get founded value
                if (foundInstringValue) {
                  table.qFound.value = stringValue;
                } else if (foundInenumValue) {
                  table.qFound.value = enumValue.displayName;
                }
                break;
              } else if (columnName && columnName.match(qRegExPartial)) {
                // find in column name
                table.qFound.element = 'Column name';
                table.qFound.value = columnName;
                break;
              }
            }
          }
        }
      }
    },
    onBuscar: function onBuscar() {},
    onOpen: function onOpen() {
      var valor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.log(valor, 'abrir modal tablas');
      this.external_row = valor;
      this.isRequest = false;
      this.objToRequest = null;
      this.queryResponse = {};
      this.textSearch = '';
      this.messageEmptyList = textsDefaul.NOT_FOUND;
      // this.key_search_table += 1
      this.$refs.dialogTable.onOpen();
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? this.pick_domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.fixQuery(this.textSearch || this.Q_DEFAULT || this.Q_DEFAULT_DEFAULT || '') : _ref$query,
        _ref$noProcessQuery = _ref.noProcessQuery,
        noProcessQuery = _ref$noProcessQuery === void 0 ? !!this.mainQueryAdvance : _ref$noProcessQuery,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.PAGE_SIZE : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? true : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? false : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? false : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        noProcessQuery: noProcessQuery
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    processParamsV2: function processParamsV2(table_view_send) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var _ref2 = params || {},
        _ref2$email = _ref2.email,
        email = _ref2$email === void 0 ? window.userInfo.email : _ref2$email,
        _ref2$domain = _ref2.domain,
        domain = _ref2$domain === void 0 ? this.pick_domain : _ref2$domain,
        _ref2$query = _ref2.query,
        query = _ref2$query === void 0 ? this.fixQuery(table_view_send || this.Q_DEFAULT || this.Q_DEFAULT_DEFAULT || '') : _ref2$query,
        _ref2$noProcessQuery = _ref2.noProcessQuery,
        noProcessQuery = _ref2$noProcessQuery === void 0 ? !!this.mainQueryAdvance : _ref2$noProcessQuery,
        _ref2$pageSize = _ref2.pageSize,
        pageSize = _ref2$pageSize === void 0 ? this.PAGE_SIZE : _ref2$pageSize,
        _ref2$searchWithTags = _ref2.searchWithTags,
        searchWithTags = _ref2$searchWithTags === void 0 ? true : _ref2$searchWithTags,
        _ref2$allDomains = _ref2.allDomains,
        allDomains = _ref2$allDomains === void 0 ? false : _ref2$allDomains,
        _ref2$approval_flow = _ref2.approval_flow,
        approval_flow = _ref2$approval_flow === void 0 ? false : _ref2$approval_flow,
        _ref2$nextToken = _ref2.nextToken,
        nextToken = _ref2$nextToken === void 0 ? undefined : _ref2$nextToken,
        _ref2$conditions = _ref2.conditions,
        conditions = _ref2$conditions === void 0 ? undefined : _ref2$conditions;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        noProcessQuery: noProcessQuery
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    getRamdonKey: function getRamdonKey() {
      return Math.round(Math.random() * 1000);
    },
    nextPage: function nextPage(page) {
      this.page = page;
      this.reloadListV2();
    },
    reloadListV2: function reloadListV2() {
      var _this = this;
      tasks.lockScreen.lock();
      var params = {
        domain: this.pick_domain,
        object_comma: TYPSE_SENSE_TYPE_OBJECTS.TABLE + ',' + TYPSE_SENSE_TYPE_OBJECTS.VIEW,
        page: this.page,
        per_page: 10,
        q: this.textSearch,
        query_by_comma: ''
      };
      search_engine_service.getBuscador(params).then(function (response) {
        tasks.lockScreen.unlock();
        _this.encontrado = response;
        _this.existeBusqueda = _this.encontrado.found > 0;
      }, function (err) {
        tasks.lockScreen.unlock();
      }).then(function () {
        var tables_send = [];
        var views_send = [];
        var test = _this.encontrado.busqueda;
        if (!test) return;
        var tables = test.filter(function (table) {
          return table.tipo_objeto == "table";
        });
        var views = test.filter(function (view) {
          return view.tipo_objeto == "view";
        });
        if (views.length > 0) {
          views.forEach(function (item) {
            views_send.push({
              projectId: item.proyecto,
              datasetId: item.dataset,
              tableId: item.titulo,
              domain_table: item.dominio,
              is_view: true,
              source: item.source ? item.source : "bigquery"
            });
          });
          var _params = {
            'tables': views_send
          };
          AssignmentsService.getTablesDetails(_params).then(function (response) {
            var views_metadata = response.data;
            views = views.map(function (item) {
              var temp = Object.assign({}, item);
              var view = temp;
              var id = view.proyecto + ":" + view.dataset + "." + view.titulo;
              var bytes = views_metadata[id].numBytes || '0';
              var numRows = views_metadata[id].numRows || '0';
              var numColumns = views_metadata[id].schema.fields ? views_metadata[id].schema.fields.length : '0';
              temp.numColumns = numColumns;
              temp.numBytes = bytes;
              temp.numRows = numRows;
              var partition = views_metadata[id].timePartitioning;
              if (partition) {
                temp.partition = partition;
              }
              return temp;
            });
            _this.encontrado.busqueda = _this.encontrado.busqueda.map(function (obj) {
              return views.find(function (o) {
                return o.titulo === obj.titulo && o.dataset === obj.dataset && o.proyecto === obj.proyecto;
              }) || obj;
            });
          });
        }
        if (tables.length > 0) {
          tables.forEach(function (item) {
            tables_send.push({
              projectId: item.proyecto,
              datasetId: item.dataset,
              tableId: item.titulo,
              domain_table: item.dominio,
              source: item.source ? item.source : "bigquery"
            });
          });
          var _params2 = {
            'tables': tables_send
          };
          AssignmentsService.getTablesDetails(_params2).then(function (response) {
            var tables_metadata = response.data;
            tables = tables.map(function (item) {
              var temp = Object.assign({}, item);
              var table = temp;
              var id = table.proyecto + ":" + table.dataset + "." + table.titulo;
              var bytes = tables_metadata[id].numBytes || '0';
              var numRows = tables_metadata[id].numRows || '0';
              var numColumns = tables_metadata[id].schema.fields ? tables_metadata[id].schema.fields.length : '0';
              temp.numColumns = numColumns;
              temp.numBytes = bytes;
              temp.numRows = numRows;
              var partition = tables_metadata[id].timePartitioning;
              if (partition) {
                temp.partition = partition;
              }
              return temp;
            });
            _this.encontrado.busqueda = _this.encontrado.busqueda.map(function (obj) {
              return tables.find(function (o) {
                return o.titulo === obj.titulo && o.dataset === obj.dataset && o.proyecto === obj.proyecto;
              }) || obj;
            });
          });
        }
      });
    },
    onRequestObjeto: function onRequestObjeto(item) {
      var _this2 = this;
      var defaultParams = this.processParamsV2(item.titulo);
      this.queryResponse = {};
      this.queryResponse.tables = [];
      this.onloading = true;
      this.messageEmptyList = textsDefaul.LOADING;
      TablesService.queryTables(defaultParams).then(function (response) {
        _this2.onloading = false;
        if (response && response.code === 200) {
          if (response.data && response.data.tables && response.data.tables.length) {
            var ref = _this2.getTableReference(item);
            var match = response.data.tables.find(function (t) {
              return t.tableReference && t.tableReference.projectId === ref.projectId && t.tableReference.datasetId === ref.datasetId && t.tableReference.tableId === ref.tableId;
            });
            if (match) {
              _this2.openRequestAccess(match);
            } else {
              tasks.toast.warning(_this2.$t('search.no_results'));
            }
          }
        }
      });
    },
    getTableReference: function getTableReference(item) {
      var tableReference = {
        datasetId: item.dataset,
        projectId: item.proyecto,
        tableId: item.titulo
      };
      return tableReference;
    },
    reloadList: function reloadList(params) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      if (!this.textSearch || this.textSearch.trim().length == 0) {
        this.$toast.warning('Ingrese un texto a buscar.');
        return;
      }
      if (!this.textSearch || this.textSearch.trim().length < 3) {
        this.$toast.warning('Ingrese al menos 3 letras.');
        return;
      }
      var self = this;
      var defaultParams = this.processParams(params);
      this.queryResponse = {};
      this.queryResponse.tables = [];
      this.onloading = true;
      this.messageEmptyList = textsDefaul.LOADING;
      TablesService.queryTables(defaultParams).then(function (response) {
        _this3.onloading = false;
        if (response && response.code === 200) {
          if (response.data && response.data.tables && response.data.tables.length) {
            self.queryResponse = response.data || {};
          } else if (response.data && !response.data.tables.length) {
            // replace empty message
            self.messageEmptyList = textsDefaul.NOT_FOUND;
            self.queryResponse = response.data || {};
            var tables = self.queryResponse.tables;
            if (tables.every(function (table) {
              return !(table.columnFields && table.columnFields.length);
            })) {
              self.queryResponse.tables = [];
              self.messageEmptyList = textsDefaul.NOT_FOUND;
            }
            self.queryResponse.tables.forEach(function (item) {
              item['tags'].forEach(function (tag) {
                if (tag.templateDisplayName == 'tpl_tables') {
                  item['defaultFields'] = tag;
                }
              });
            });
          } else {
            self.messageEmptyList = textsDefaul.NOT_FOUND;
            self.queryResponse = {};
          }
        } else if (response && response.code === 400) {
          // alert(response.message)
          self.messageEmptyList = textsDefaul.NOT_FOUND;
        } else {
          // self.reloadList(defaultParams, callback)
        }
        // callback from pagination
        _this3.isNewQuery = false;
        callback && callback(response);
      });
    },
    checkDomain: function checkDomain(item) {
      return item.domain_table === window.userInfo.domain;
    },
    openRequestAccess: function openRequestAccess(item) {
      var _this4 = this;
      var rowData = utils.cloneJSON(item);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this4.objToRequest = response.data;
          _this4.objToRequest.item = rowData;
          _this4.objToRequest.tipo = 'edicion';
          _this4.isRequest = true;
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    getMessageProductivize: function getMessageProductivize() {
      return 'Solicitud generada por módulo attributes marketplace para proceso de pase a producción ' + 'para caso de uso ' + this.external_row.table_sandbox + ' en empresa ' + this.companyName + '.El usuario que ha generado la solicitud es:' + window.userInfo.email + '.';
    },
    openRequestPMAccess: function openRequestPMAccess(item) {
      var _this5 = this;
      var default_message = 'Solicitud generada por módulo attributes marketplace para proceso de pase a producción ' + 'para caso de uso ' + this.external_row.table_sandbox + ' en empresa ' + this.companyName + '.El usuario que ha generado la solicitud es:' + window.userInfo.email + '.';
      var rowData = utils.cloneJSON(item);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          var column_values = response.data.objects.tags.filter(function (field) {
            return field.column !== undefined && field.column !== null;
          }).map(function (field) {
            return field.column.toString();
          });
          if (!_this5.containsAll(column_values, _this5.external_row.attribute_names)) {
            tasks.toast.info('La tabla no tiene los mismos campos que el caso de uso');
            return;
          }
          var filtered_fields = response.data.objects.tags.filter(function (field) {
            return column_values.includes(field.column) || field.column === undefined || field.column === null;
          });
          var operatorDisplayName = null;
          var currentDate = new Date();
          var _iterator = _createForOfIteratorHelper(response.data.objects.tags),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var tag = _step.value;
              if (tag.templateDisplayName === 'tpl_tables' && tag.fields.operator) {
                operatorDisplayName = tag.fields.operator.stringValue;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var _rowData = utils.cloneJSON(item);
          currentDate.setFullYear(currentDate.getFullYear() + 20);
          var twenty_years = "".concat(currentDate.getFullYear(), "-").concat(String(currentDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(currentDate.getDate()).padStart(2, '0'));
          var data_to_send = {
            'operator': operatorDisplayName,
            'type_flow': 'ACCESS',
            'table_id': item.tableReference.tableId,
            'relativeResourceName': _rowData.relativeResourceName,
            'commentary': default_message,
            'fields': filtered_fields,
            'tableReference': item.tableReference,
            'endDate': twenty_years,
            'applicant': window.userInfo.email,
            'extraParams': {
              'files': [],
              'isExternalUser': true,
              'isServiceAccount': false,
              'isDigitalAudience': false,
              'isAttributes': false,
              'isProductivize': true,
              'benefited': '',
              'businessCase': _this5.external_row.table_sandbox
            },
            'index_node': _rowData.index_node,
            'domain_table': _rowData.domain_table
          };
          console.log(data_to_send);
          AssignmentsService.initApprovalFlow(data_to_send).then(function (response) {
            if (response.code === 200) {
              if (!response.success) {
                _this5.message = response.message;
                tasks.toast.error(_this5.message);
              } else {
                tasks.toast.success('Successful request!');
              }
            }
          }).catch(function (e) {
            // hide modal show alert and reload page
            utils.printError(e);
          });
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    validateIdField: function validateIdField(fields) {
      console.log(fields, 'fields');
      var idFieldExists = false;
      var _iterator2 = _createForOfIteratorHelper(fields),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var field = _step2.value;
          if (field.column === 'id') {
            idFieldExists = true;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return idFieldExists;
    },
    arrayContains: function arrayContains(arr1, arr2) {
      if (arr1.length < arr2.length) {
        return false;
      }
      var sortedArr1 = arr1.slice().sort();
      var sortedArr2 = arr2.slice().sort();
      for (var i = 0; i < sortedArr1.length; i++) {
        if (!sortedArr1.includes(sortedArr2[i])) {
          return false;
        }
      }
      return true;
    },
    containsAll: function containsAll(arr1, arr2) {
      return arr2.every(function (element) {
        return arr1.includes(element);
      });
    },
    sendRequest: function sendRequest() {
      this.isRequest = false;
      this.queryResponse = {};
      this.$refs.dialogTable.onClose();
    },
    onCancelar: function onCancelar() {
      this.isRequest = false;
      this.objToRequest = null;
      this.queryResponse = {};
    },
    fixQuery: function fixQuery(q) {
      if (!q.match(TAG_QUERIES.ALL_WITH_OWNER)) {
        q = "".concat(q, " ").concat(TAG_QUERIES.ALL_WITH_OWNER);
      }
      return q;
    }
  }
};